import {useSelector} from "react-redux";

import {selectReducerGuiEventsState,} from "./select";

export const useGuiEvents = () => useSelector(selectReducerGuiEventsState);
